import { useState } from 'react';
import Contact from './components/Contact';
import SeoJsonLd from '../../components/SeoJsonLd';

export default function HomePage() {
  const [showProfile, setShowProfile] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "치즈문스튜디오",
        "url": siteUrl,
        "logo": {
          "@type": "ImageObject",
          "url": "https://static.readdy.ai/image/0f896a9214ea337d0191b3b0d641ded7/cd1d2483382737a2fb51d8ea12cde1bc.png"
        },
        "sameAs": [
          "https://www.youtube.com/@czm_studio",
          "https://www.instagram.com/czm_studio/"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+82-10-4340-8488",
          "contactType": "customer service",
          "email": "cheezemoonstudio@gmail.com",
          "areaServed": "KR",
          "availableLanguage": "Korean"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2F, 31, Yeonnam-ro 3-gil, Mapo-gu",
          "addressLocality": "Seoul",
          "addressCountry": "KR"
        }
      },
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#localbusiness`,
        "name": "치즈문스튜디오",
        "image": "https://static.readdy.ai/image/0f896a9214ea337d0191b3b0d641ded7/cd1d2483382737a2fb51d8ea12cde1bc.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2F, 31, Yeonnam-ro 3-gil, Mapo-gu",
          "addressLocality": "Seoul",
          "addressCountry": "KR"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "37.5665",
          "longitude": "126.9780"
        },
        "telephone": "+82-10-4340-8488",
        "email": "cheezemoonstudio@gmail.com",
        "url": siteUrl,
        "priceRange": "$$",
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        }
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "치즈문스튜디오",
        "description": "치즈문 스튜디오는 K-POP 아티스트 콘텐츠, 웹예능, 브랜드 영상, 인터뷰를 기획·촬영·편집까지 원스톱으로 제작하는 영상 프로덕션입니다.",
        "publisher": {
          "@id": `${siteUrl}/#organization`
        },
        "inLanguage": "ko-KR"
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "뉴미디어 콘텐츠 제작 프로덕션 '치즈문 스튜디오'입니다",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#organization`
        },
        "description": "치즈문 스튜디오는 K-POP 아티스트 콘텐츠, 웹예능, 브랜드 영상, 인터뷰를 기획·촬영·편집까지 원스톱으로 제작하는 영상 프로덕션입니다.",
        "inLanguage": "ko-KR"
      },
      {
        "@type": "Service",
        "serviceType": "영상 제작",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Seoul"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "영상 제작 서비스",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "기획 & 촬영",
                "description": "K-POP 아티스트 콘텐츠, 웹예능, 브랜드 영상, 인터뷰 기획 및 촬영"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "컬러 그레이딩",
                "description": "영상의 감성과 분위기를 완성하는 전문 색감 작업"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "편집 & 후반작업",
                "description": "컬러 그레이딩부터 모션 그래픽까지 원스톱 후반작업"
              }
            }
          ]
        }
      },
      {
        "@type": "VideoObject",
        "name": "치즈문스튜디오 영상 제작 포트폴리오",
        "description": "K-POP 아티스트 콘텐츠, 웹예능, 브랜드 영상 제작 사례",
        "thumbnailUrl": "https://static.readdy.ai/image/0f896a9214ea337d0191b3b0d641ded7/cd1d2483382737a2fb51d8ea12cde1bc.png",
        "uploadDate": "2025-01-01",
        "contentUrl": siteUrl
      }
    ]
  };

  return (
    <>
      <SeoJsonLd data={schemaData} />
      <div className="bg-black">
        <h1 className="sr-only">뉴미디어 콘텐츠 제작 프로덕션 치즈문 스튜디오</h1>
        
        {/* Main Section */}
        <div className="min-h-screen flex flex-col items-center justify-center px-4 sm:px-8">
          <div className="flex flex-col items-center justify-center gap-6 sm:gap-10 -mt-16 sm:-mt-32">
            <a
              href="https://www.youtube.com/@czm_studio"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer w-full max-w-[280px] sm:max-w-[450px]"
            >
              <img
                src="https://static.readdy.ai/image/0f896a9214ea337d0191b3b0d641ded7/cd1d2483382737a2fb51d8ea12cde1bc.png"
                alt="치즈문스튜디오 로고 - 영상 제작 프로덕션"
                title="치즈문스튜디오 - 영상 제작 편집"
                className="w-full h-auto animate-float"
              />
            </a>
            
            <div className="flex items-center gap-6 sm:gap-10">
              <a
                href="https://www.youtube.com/@czm_studio"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-400 transition-colors cursor-pointer"
                aria-label="치즈문스튜디오 유튜브 채널"
              >
                <i className="ri-youtube-fill w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-3xl sm:text-4xl"></i>
              </a>
              <a
                href="https://www.instagram.com/czm_studio/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-400 transition-colors cursor-pointer"
                aria-label="치즈문스튜디오 인스타그램"
              >
                <i className="ri-instagram-fill w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-3xl sm:text-4xl"></i>
              </a>
              <a
                href="mailto:cheezemoonstudio@gmail.com"
                className="text-white hover:text-gray-400 transition-colors cursor-pointer"
                aria-label="치즈문스튜디오 이메일 문의"
              >
                <i className="ri-mail-fill w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-3xl sm:text-4xl"></i>
              </a>
            </div>
          </div>

          <div className="absolute bottom-16 sm:bottom-32 text-center px-4">
            <p className="text-gray-200 text-xs sm:text-sm font-light">
              서울 마포구 연남로3길 31, 2층
            </p>
            <p className="text-gray-200 text-xs sm:text-sm font-light mt-2">
              +82.10.4340.8488
            </p>
          </div>
        </div>

        {/* Company Profile Section */}
        <div className="min-h-screen flex items-center justify-center px-4 sm:px-8 py-24 sm:py-48 border-t border-gray-900">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-white text-xl sm:text-4xl mb-6 sm:mb-8 tracking-widest" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              치즈문 스튜디오&nbsp;&nbsp;회사 소개서
            </h2>
            <p className="text-white text-base sm:text-lg font-light leading-relaxed mb-10 sm:mb-14 max-w-lg mx-auto">
              우리는 콘텐츠를 만듭니다. 기억에 남게.
            </p>
            <div className="w-full flex justify-center">
              <button
                onClick={() => setShowProfile(true)}
                className="flex flex-col items-center gap-1 cursor-pointer group"
                aria-label="회사 소개서 보기"
              >
                {/* Windows folder icon */}
                <div className="animate-gentle-bounce">
                  <div className="relative w-20 h-16 sm:w-24 sm:h-20">
                    {/* Folder tab */}
                    <div className="absolute top-0 left-0 w-8 sm:w-10 h-2.5 sm:h-3 rounded-tl-sm rounded-tr-md bg-yellow-400 group-hover:bg-yellow-300 transition-colors"></div>
                    {/* Folder body */}
                    <div className="absolute top-2 sm:top-2.5 left-0 w-full h-[52px] sm:h-[62px] rounded-tr-md rounded-b-md bg-yellow-400 group-hover:bg-yellow-300 transition-colors flex items-center justify-center">
                      {/* Folder shine */}
                      <div className="absolute top-1.5 left-2 right-2 h-1.5 bg-yellow-200/40 rounded-full"></div>
                    </div>
                  </div>
                </div>
                <span className="text-white text-xs sm:text-sm font-normal tracking-wide mt-1 group-hover:text-gray-300 transition-colors" style={{ fontFamily: 'sans-serif' }}>회사 소개서</span>
              </button>
            </div>
          </div>
        </div>

        {/* PDF Preview Modal */}
        {showProfile && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
            onClick={() => setShowProfile(false)}
          >
            <div
              className="relative w-full max-w-4xl mx-4 bg-black border border-white/10"
              style={{ height: '90vh' }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between px-5 py-3 border-b border-white/10">
                <p className="text-white text-xs tracking-widest uppercase">Company Profile</p>
                <div className="flex items-center gap-4">
                  <a
                    href="https://drive.google.com/file/d/1gQCczOz5JuZsqNpAHujM2KcBDUeI-75S/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors text-xs tracking-widest uppercase cursor-pointer whitespace-nowrap"
                  >
                    새 탭에서 열기
                  </a>
                  <button
                    onClick={() => setShowProfile(false)}
                    className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
                    aria-label="닫기"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>
              </div>
              {/* PDF Embed */}
              <iframe
                src="https://drive.google.com/file/d/1gQCczOz5JuZsqNpAHujM2KcBDUeI-75S/preview"
                title="치즈문스튜디오 회사 소개서"
                className="w-full"
                style={{ height: 'calc(90vh - 48px)' }}
                allow="autoplay"
              />
            </div>
          </div>
        )}

        {/* About Section */}
        <div className="min-h-screen flex items-center justify-center px-4 sm:px-8 py-24 sm:py-48 border-t border-gray-900">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-white text-4xl sm:text-6xl mb-12 sm:mb-16 tracking-tight" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              Our Philosophy
            </h2>
            <p className="text-gray-200 text-base sm:text-2xl font-light leading-relaxed max-w-4xl mx-auto mb-8">
              치즈문스튜디오는 다작보다 완성도를 선택합니다.<br />
              우리는 한 편을 만드는 데 집요합니다.<br />
              <br />
              스토리부터 미장센, 화면의 온도까지.<br />
              눈에 먼저 남고, 오래 기억되는 <strong>영상</strong>을 만듭니다.
            </p>
          </div>
        </div>

        {/* Contact Section */}
        <Contact />

        {/* Footer */}
        <div className="border-t border-gray-900 py-8 sm:py-12 px-4 sm:px-8">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6">
            <p className="text-gray-600 text-xs sm:text-sm font-light text-center md:text-left">
              © 2026 치즈문스튜디오. All rights reserved.
            </p>
            <div className="flex items-center gap-4 sm:gap-6">
              <a
                href="https://www.youtube.com/@czm_studio"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-white transition-colors cursor-pointer"
                aria-label="유튜브"
              >
                <i className="ri-youtube-fill w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xl sm:text-2xl"></i>
              </a>
              <a
                href="https://www.instagram.com/czm_studio/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-white transition-colors cursor-pointer"
                aria-label="인스타그램"
              >
                <i className="ri-instagram-fill w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xl sm:text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
